/* ------------------------------------------------------------------------ */
/*		File: BlogsAndNews.tsx                                              */
/*		Description: Blogs & News page definition                           */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useState } from "react";
import crypt from "crypto-js";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import Card_703 from "../../components/cmpCard_703/cmpCard_703";
import { ICmpCard_703 } from "../../components/cmpCard_703/cmpCard_703.d";
import Search from "../../components/cmpSearch/cmpSearch";
import { useTranslation, withTranslation } from "react-i18next";
import { getResources } from "../../api/hooks";
import "./blogsandnews.css";
import { useParams } from "react-router-dom";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import { ToastContainer, Zoom, toast } from 'react-toastify';
import Spinner from "../../components/GenericComponents/spinner";
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */


const BlogsAndNews: React.FC = () => {
    const { t } = useTranslation();
    const params = useParams();
    const infoMenus: any = t("menu", { returnObjects: true });
    const infoResources: any = t("resources", { returnObjects: true });
    const infoSearch: any = t("search", { returnObjects: true });
    const infoOthers: any = t("others", { returnObjects: true });
    const detailMenu = infoMenus.filter((x: any) => x.id === "resources")[0] || null;

    const [resources, setResources] = useState<ICmpCard_703[]>([]);
    const [search, setSearch] = useState({ tags: params.criteria || "" });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getResources(search)
            .then((response: any) => {
                if (response.msg === "OK") {
                    let id1 = Math.floor(Math.random() * response.resources.length);
                    let id2 = Math.floor(Math.random() * response.resources.length);
                    if (id1 === id2) { id2 = id2 + 1 }

                    const related = [response.resources[id1], response.resources[id2]];
                    window.localStorage.setItem("related", crypt.AES.encrypt(JSON.stringify(related), "").toString());

                    setResources(response.resources); // Actualizar resources, no search
                }
                else {
                    setResources([]);
                }
                setIsLoading(false);
            })
            .catch(err => {
                toast.error(infoOthers.msgError)
                setResources([]);
                setIsLoading(false);
            });
    }, [search]);

    const handleSearchClick = (value: any) => {
        if (value !== search.tags) {
            setSearch({ tags: value });
        }
    };

    return (
        <div className="header-parent">
            <Meta page={"blogs"} />
            <div className="cssBlogsAndNews">
                <Menu
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />
                <div className="cssCol">
                    <Card_Breadcumb label={infoResources.breadcumb} />

                    {/* Section: Blog & News */}

                    <section id="resources">
                        <IntroComponent
                            label={infoResources.label}
                            description={infoResources.description}
                        />
                    </section>

                    {/* Section: Search */}

                    <section id="search">
                        <Search
                            card={infoSearch}
                            onClick={handleSearchClick}
                        />
                    </section>

                    {/* Section: Resources */}

                    <section id="resources">
                        {isLoading
                            ? (<Spinner isLoading={isLoading} type="container" />)
                            : (<>
                                {resources.length > 0 && resources.map((item, index) => (
                                    <Card_703
                                        key={`resources-${index}`}
                                        card={item}
                                    />
                                ))}
                            </>
                        )}

                    </section>

                </div>
            </div>
            <ToastContainer
                style={{ width: "500pt" }}
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Zoom}
            />
        </div>
    );
};

export default withTranslation('translation', { withRef: true }) (BlogsAndNews);
